export const dragTypes = {
  OCCURRENCE: "occurrence",
};
